import React from 'react';
import styled from 'react-emotion';
import { Query } from 'react-apollo';
//import gql from '@jetshop/core/gql';
import CategoryLink from '@jetshop/ui/CategoryLink';
import CategoriesQuery from './CategoryTreeQuery.gql';

// const CategoriesQuery = gql`
//   fragment CategoryPath on Category {
//     id
//     name
//     primaryRoute {
//       id
//       path
//       parents {
//         id
//       }
//     }
//     hasSubcategories
//     level
//   }

//   query CategoryTree($path: String!) {
//     route(path: $path) {
//       id
//       category: object {
//         ... on Category {
//           ...CategoryPath
//           subcategories {
//             ...CategoryPath
//             subcategories {
//               ...CategoryPath
//             }
//           }
//         }
//       }
//     }
//   }
// `;

const List = styled.ul`
  &.level-1 {
    margin-left: 1rem;
  }
`;

const Wrapper = styled.div`
  margin-bottom: 20px;
`;

export const Link = styled(CategoryLink)`
  width: 100%;
  display: block;
  color: #444;
  text-decoration: none;
  line-height: 1.1;
  padding: 5px 0 5px 1rem;
  margin-bottom: 5px;

  &:hover {
    color: ${p => p.theme.colors.active};
    text-decoration: underline;
  }

  &.level-2.active {
    font-weight: bold;
  }

  &.level-2 + ${List} {
    display: none;
    margin-left: 1rem;
  }

  &.active + ${List} {
    display: block;
  }
`;

export const ParentLink = styled(Link)`
  background: ${({ theme }) => theme.colors.leftaside.category};
  color: #fff;
  border-radius: 3px;
  padding: 2px 10px 2px 1rem;
  line-height: 1.7;
  font-weight: bold;
  margin-bottom: 5px;
`;

const CategoryTree = ({ route, category }) => {
  const useRoute = route && route.id && category === undefined;
  const pathObj = useRoute ? route : category;

  if (!pathObj || !pathObj.id) {
    return <Placeholder />;
  }

  const isSubcategory = useRoute
    ? route.parents && route.parents.length > 0
    : category.primaryRoute.parents && category.primaryRoute.parents.length > 0;

  const topParent = useRoute
    ? route.parents[route.parents.length - 1]
    : category.primaryRoute.parents[category.primaryRoute.parents.length - 1];

  if (isSubcategory && !topParent) {
    return null;
  }

  const topParentPath = isSubcategory
    ? topParent.path
    : useRoute
    ? route.path
    : category.primaryRoute.path;

  return (
    <Query query={CategoriesQuery} variables={{ path: topParentPath }}>
      {({ data, loading, error }) => {
        if (loading) {
          return <Placeholder />;
        }

        const { subcategories, name } = data.route.category;

        return (
          <Wrapper>
            <ParentLink category={data.route.category}>{name}</ParentLink>
            <List>
              {subcategories &&
                subcategories.length > 0 &&
                subcategories.map(subcategory => (
                  <Item key={subcategory.id} category={subcategory} />
                ))}
            </List>
          </Wrapper>
        );
      }}
    </Query>
  );
};

const Item = ({ category }) => {
  const { hasSubcategories, subcategories, level } = category;

  const className = `level-${level}`;

  return (
    <li>
      <Link className={className} category={category}>
        {category.name}
      </Link>
      {hasSubcategories && (
        <List className={className}>
          {subcategories.map(subcategory => (
            <Item key={subcategory.id} category={subcategory} />
          ))}
        </List>
      )}
    </li>
  );
};

const randomWidth = (min = 40, max = 70) =>
  Math.floor(Math.random() * (max - min + 1) + min);

const PlaceholderItem = styled.span`
  display: block;
  width: ${p => p.width}%;
  height: 1rem;
  background: #eee;
  margin-left: 1rem;
  margin-bottom: 1rem;
`;

const PlaceholderParent = styled.span`
  display: block;
  width: 100%;
  height: 1.9rem;
  background: ${({ theme }) => theme.colors.leftaside.category};
  border-radius: 3px;
  padding: 2px 10px 2px 1rem;
  position: relative;
  margin-bottom: 10px;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 1rem;
    transform: translateY(-50%);
    width: ${randomWidth()}%;
    height: 0.8rem;
    background: #fff;
    opacity: 0.5;
  }
`;

export const Placeholder = () => (
  <Wrapper>
    <PlaceholderParent />
    {Array.from({ length: 8 }).map((_, i) => {
      const width = randomWidth();
      return <PlaceholderItem key={i} width={width} />;
    })}
  </Wrapper>
);

export default CategoryTree;
